import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';

class WorkplaceDragPreview extends Component{
  render()  {
    const { workplace: {name}, shouldPreviewBeSmall, position } = this.props;
    return (
      <div style={[styles.container, !shouldPreviewBeSmall && styles.shouldPreviewBeSmall, position.columnIndex===8 && styles.isInvoiced]}>

        <div style={[styles.dragable]}>
          <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
        </div>
        <div style={styles.projectHeader}>
          {name}
        </div>
{/*        <div style={styles.workplaceName}>
          {name}
        </div>
        <div style={styles.client}>
          {client.name}
          <br />
          {client.contact.name}
        </div>
        <div style={styles.employeesContainer}>
          {
            Object.keys(employees).map((employeeId)=>{
              return <div key={employees[employeeId].id} style={styles.employeeInitials}>{employees[employeeId].initials}</div>
            })
          }
        </div>*/}
      </div>
    );
  }
}

var styles = {
  container: {
    textAlign: 'center',
    width: '215px',
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '8px',
    borderRadius: '2px',
    fontSize: '12px',
    padding: '6px 34px 0 34px',
    position: 'relative',
    height: '39px',
    overflow: 'hidden'
  },
  shouldPreviewBeSmall: {
    width: '180px'
  },
  dragable: {
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px',
    position: 'absolute',
    left: '0',
    top: '0'
  },
  projectHeader: {
    fontWeight: '600',
/*    lineHeight: '14px',
*/    height: '35px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    lineHeight: '25px'
  },
  workplaceName: {
    padding: '4px 0'
  },
  client:{
    padding: '4px 0',
    borderBottom: '1px solid ' + semanticColors.mainBackground
  },
  employeesContainer: {
    minHeight: '20px',
    padding: '4px 0',
    margin: '0 -2px'
  },
  employeeInitials: {
    display: 'inline-block',
    height: '20px',
    lineHeight: '20px',
    width: '35px',
    margin: '1px',
    backgroundColor: semanticColors.mainBackground,
    borderRadius: '2px'
  },
  isInvoiced: {
    backgroundColor: semanticColors.successLight
  }
}

  WorkplaceDragPreview.propTypes = {
    workplace: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      client: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        contact: PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired
        }).isRequired
      }).isRequired,
      project: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired
      }).isRequired,
      employees: PropTypes.object.isRequired
    }),
    shouldPreviewBeSmall: PropTypes.bool.isRequired,
    position: PropTypes.shape({
      columnIndex: PropTypes.number.isRequired,
      index: PropTypes.number.isRequired
    })
  };
export default Radium(WorkplaceDragPreview)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/workplaceDragPreview.jsx